export type CapabilityRefMatch = { start: number; end: number; ref: string };

// Same grammar as the API and the minions runtime: an @ inside an email or identifier is plain text.
const capabilityRef =
  /(?<![\p{L}\p{N}_.!#$%&'*+/=?^`{|}~-])@([a-z0-9_]+\.[a-z0-9_]+)(?=$|[^\p{L}\p{N}_.]|\.(?![\p{L}\p{N}_]))/gu;

export function findCapabilityRefs(value: string): CapabilityRefMatch[] {
  return [...value.matchAll(capabilityRef)].map((match) => ({
    start: match.index ?? 0,
    end: (match.index ?? 0) + match[0].length,
    ref: match[1]!,
  }));
}
